import { render } from "./ItemMasterUpload.vue?vue&type=template&id=4bb23f72"
import script from "./ItemMasterUpload.vue?vue&type=script&lang=js"
export * from "./ItemMasterUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__